import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Button,
	Table,
	TableHead,
	TableRow,
	TableCell,
	Checkbox,
	TableBody
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";

import { Helmet } from "react-helmet-async";

import { FiChevronDown } from "react-icons/fi";

import useStyles from "./styles";
import Spinner from "Components/Spinner";

import actions from "store/actions";

import _ from "lodash";

import ls from "Localization";
import { State } from "store/reducers";
import { SubscriptionState } from "store/reducers/subscription";
import { toStringCurrency } from "helpers/string";

import IPlan from "Types/Plan";
import dayjs from "dayjs";
import IBankBillet, { BankBilletStatus } from "Types/BankBillet";
import { InstallmentStatus } from "Types/Installment";

const ls2: any = ls;

function SubscriptionPay() {
	const dispatch = useDispatch<any>();
	const classes = useStyles({});

	useEffect(() => {
		dispatch(actions.subscription.clearValues());
		dispatch(actions.subscription.getInstallmentsForOperator());
	}, [dispatch]);

	const [showInfoPanel, setShowInfoPanel] = useState(true);

	const { loading, installments: items } = useSelector<
		State,
		SubscriptionState
	>(s => s.subscription);

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		dispatch(
			actions.subscription.generateInstallmentsBankBillet(
				items,
				(err, model: any) => {
					if (err) {
						console.log(err);
						if (err.code) {
							alert(err.code);
						} else if (typeof err === "string") alert(err);
						else alert(JSON.stringify(err));
					} else {
						window.open(model.url, "_blank");
						alert(
							"Boleto gerado e será aberto em outra aba, caso não abra, verifique se seu navegador bloqueou a ação"
						);
					}
				}
			)
		);
	};

	return (
		<form onSubmit={handleSubmit} noValidate>
			<Helmet>
				<title>
					{ls.invoices} | {ls.appName}
				</title>
			</Helmet>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Accordion
						TransitionProps={{ unmountOnExit: true }}
						expanded={showInfoPanel}
						onChange={() => setShowInfoPanel(prev => !prev)}
					>
						<AccordionSummary
							expandIcon={<FiChevronDown />}
							aria-controls="finishes-content"
							id="finishes-header"
						>
							<Typography className={classes.heading} variant="h6">
								{ls.invoices}
							</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Table>
								<TableHead>
									<TableRow>
										<TableCell>Nome do MEI</TableCell>
										<TableCell>Descrição</TableCell>
										<TableCell>Valor</TableCell>
										<TableCell>Data vencimento</TableCell>
										<TableCell>Status</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{items.map((c: any) => {
										return (
											<TableRow key={c._id}>
												<TableCell>
													<b>
														{c.user?.name} {c.user?.lastname}
													</b>
												</TableCell>
												<TableCell>
													Parcela {c.number}/{c.subscription.installment} -{" "}
													{(c.subscription.plan as IPlan).name}
												</TableCell>
												<TableCell>
													{toStringCurrency(+c.value / 100.0)}
												</TableCell>
												<TableCell>
													{dayjs(c.paymentDate).format("DD/MM/YYYY")}
												</TableCell>
												<TableCell>
													{c.transaction ? (
														(c.transaction as IBankBillet)?.status ===
														BankBilletStatus.pending ? (
															<a
																href={(c.transaction as IBankBillet).url}
																target="_blank"
															>
																Aguardando pagamento
															</a>
														) : (
															""
														)
													) : (
														ls2[InstallmentStatus[c.status]]
													)}
												</TableCell>
											</TableRow>
										);
									})}
								</TableBody>
							</Table>
						</AccordionDetails>
					</Accordion>
				</Grid>

				<Grid item xs={12}>
					<Grid container justifyContent="flex-end">
						<Grid item>
							<Button
								disabled={loading.pay}
								variant="contained"
								color="secondary"
								type="submit"
							>
								Gerar boleto
								{loading.pay && (
									<Spinner size={20} style={{ marginLeft: 16 }} />
								)}
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</form>
	);
}

export default SubscriptionPay;
